<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <meta http-equiv="X-UA-Compatible" content="ie=edge" />
  <title>Energy Doctor</title>
</head>

<body>

  <div class="">
    <div class="login">
      <div class="row">
        <div class="col-md-6 col-lg-6 f-bg">
          <div class="login-left-image" id="login-left-image-id"></div>
        </div>
        <div class="col-md-6 col-lg-6">
          <form [formGroup]="loginForm" (ngSubmit)="login()" class="width100 login-form-container" id="loginForm">
            <fieldset>
              <div>
                <div class="maindiv">
                  <div class="logobanner">
                    <img src="{{logopath}}" class="img-fluid" id="logologinpage"/>
                    <p class="
                          text-muted text-uppercase text-decoration-none
                          font-weight-bold
                          logo1
                          logintxt
                        ">

                    </p>
                  </div>

                  <div class="welcome-section login-inner-content-area">
                    <h3 class="
                          banner1 login-heading login-heading-space
                        ">
                      <span>Welcome To</span><br />Remote Monitoring System
                    </h3>
                    <div class="floating-form">
                      <p class="invalid">{{ errorMsg }}</p>
                      <div class="fxg-field input-field-w">
                        <label id="NavLoginUserId-label" for="NavLoginUserId" style="display: none"
                          class="Navuser">Email Address</label>
                        <input id="NavLoginUserId" type="text" class="fxg-field__input-text fxg-field__input-text-login fxg-field__input--required
                        sessioncamexclude" formControlName="UserName" name="UserName" required="" title="Username"
                          aria-required="true" data-errmsg="Sorry, this is a required field." />
                        <span class="
                              fxg-field__placeholder
                              fxg-field__floating-placeholder
                            " tabindex="-1">Email Address</span>
                        <div>
                          <p class="error_msg" *ngIf="displayMessage.UserName">
                            {{ displayMessage.UserName }}
                          </p>
                        </div>
                      </div>
                      <div class="fxg-field input-field-w margin-top-30">
                        <label id="NavLoginUserId-label" for="NavLoginUserId" style="display: none"
                          class="Navuser">Password</label>
                        <input id="NavLoginUserId" type="password" class="
                        fxg-field__input-text fxg-field__input-text-login fxg-field__input--required
                        sessioncamexclude" id="passwordId" formControlName="Password" (blur)="blur()" name="Password" required=""
                          title="Password" aria-required="true" data-errmsg="Sorry, this is a required field." />
                        <span class="
                              fxg-field__placeholder
                              fxg-field__floating-placeholder
                            " tabindex="-1">Password</span>
                        <div style="position: relative">
                          <p class="error_msg" *ngIf="displayMessage.Password">
                            {{ displayMessage.Password }}
                          </p>
                        </div>
                      </div>
                      <p class="text-box-mt-15 forgot">
                        <a id="Forgot-Password" href="/forgot-password" class="
                              forgot
                              text-decoration-none 
                              small
                             
                            ">Forgot Password?</a>
                      </p>
                      <div class="Login_clickinfo">
                        <button class="btncommon btn-submit-bg" type="submit" id="Login-btn">
                          Login
                        </button>
                      </div>
                      <div class="text-w text-box-mt-15">

                        <p class="account account34">
                          Don't have account?<span><a href="register" class="pl-1 text-decoration-none" id="lblloginsignup">Sign
                              up</a></span>
                          <!-- <img class="float-right margin-left-5 cursor-pointer loginimg" src="..\assets\images\login.png"
                                                  alt="loginicon"> -->
                          <!-- <a class="text-muted text-uppercase text-decoration-none font-weight-bold login2 logintxt"
                                                  (click)="login()">Login</a> -->
                        </p>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    </div>
  </div>
</body>

</html>